import gql from 'graphql-tag';

const fragments = {};

fragments.userFields = gql`
  fragment userFields on UserType {
    id
    image {
        url
    }
    username
    fullName
    email
    isAdmin
    isOnline
  }
`;

fragments.couponFields = gql`
  fragment couponFields on CouponType {
    id
    title
    text
    normalPrice
    newPrice
    discountPercentage
    url
    cta
    barcode
    qrCode
    partnerName
    partnerAddress
    partnerPostCode

    # Readonly:
    images {
        url
        id
    }
  }
`;

fragments.completeCouponFields = gql`
  fragment completeCouponFields on CouponType {
    id
    title
    text
    normalPrice
    newPrice
    discountPercentage
    partnerName
    partnerAddress
    partnerPostCode
    cta
    timesSent
    ctaCount
    barcode
    qrCode
    url
    campaign {
        endDate
        endTime
        daysActive
        organization {
            name
            address
            currencySymbol
        }
    }

    # Readonly:
    images {
        url
        id
    }
  }
`;

fragments.campaignFields = gql`
  fragment campaignFields on CampaignType {
    id
    notificationTitle
    notificationDescription
    startDate
    endDate
    startTime
    endTime
    daysActive
    delay
    coupons {
      ...couponFields
    }
  }

${fragments.couponFields}`;

fragments.organizationFields = gql`
  fragment organizationFields on OrganizationType {
    id
    name
    subtitle
    address
    currencySymbol
    timezone
    city
    streetAddress
    postcode
    country
    email
    currency {
      id
    }

    image {
        url
    }

    users {
      ...userFields
    }

    dashboardCampaigns {
      ...campaignFields
    }
  }

${fragments.userFields}
${fragments.campaignFields}`;

fragments.appStateUserFields = gql`
  fragment appStateUserFields on UserType {
    ...userFields

    organization {
      ...organizationFields
    }
  }

${fragments.organizationFields}
${fragments.userFields}`;

export default fragments;
